import { useEffect, useRef, useState } from "react";
import { useVisit } from "../../../context/VisitProvider";
import { useLocation, useParams } from "react-router-dom";

export default function Tracker({ children, moduleName }) {
  const location = useLocation();
  const intervalRef = useRef();
  const { setModuleVisits } = useVisit();
  const { subject, chapter, topic, module } = useParams();

  useEffect(() => {
    if (moduleName) {
      // Initialize visit if not already stored
      const gradeSection = window.localStorage.getItem("selectedClass");
      const [grade, section] = (gradeSection || "").split("-");

      setModuleVisits({
        teacherId: window.localStorage.getItem("userId") || "unknown",
        moduleId: module,
        module: moduleName,
        subject,
        chapter,
        topic,
        grade,
        section,
      });

      // Interval: update `updatedOn` every 2 seconds
      intervalRef.current = setInterval(() => {
        const key = "visit:page";
        const raw = window.localStorage.getItem(key);
        if (!raw) return;

        const visits = JSON.parse(raw);
        if (visits[module]) {
          visits[module].updatedOn = Date.now();
          window.localStorage.setItem(key, JSON.stringify(visits));
        }
      }, 2000);
    }
    return () => clearInterval(intervalRef.current); // cleanup when leaving page
  }, [location.pathname, setModuleVisits, moduleName]);

  return <div>{children}</div>;
}
